import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {Partner} from "../../../../shared/interface/partner";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {PartnerService} from "../../../../shared/services/partner.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  ChangeRegionalDialogData
} from "../../../partners/change-account-number-dialog/change-account-number-dialog.component";
import {validIban} from "../../../../shared/validator/iban-validator";
import {PermissionsTag} from "../../../../shared/interface/permissions-tag";
import {delay, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {UserService} from "../../../../shared/services/user.service";

export interface permissionTagDialogData {
  permissionTag: number;
}

@Component({
  selector: 'app-add-permission-tag-user',
  templateUrl: './add-permission-tag-user.component.html',
  styleUrls: ['./add-permission-tag-user.component.scss']
})
export class AddPermissionTagUserComponent implements OnInit, OnDestroy {

  accountUserControl: FormControl;
  addPermissionTagForm: FormGroup;
  permissionTagId: number;
  processingRequest = false;
  enableSaveButton = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<AddPermissionTagUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: permissionTagDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private userService: UserService,
    private snack: MatSnackBar
  ) {
    this.permissionTagId = data.permissionTag;
    this.addPermissionTagForm = fb.group({
      accountUser: this.accountUserControl = fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.addPermissionTagForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.addPermissionTagForm.valid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    this.processingRequest = true;

    this.userService.addPermissionTag({permissionTag: this.permissionTagId} , this.accountUserControl.value)
      .subscribe(() => {
        this.snack.open('Pomyślnie dadano użytkownika', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas dodawania użytkownika wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }
}
